export const revealTrainers = (data: any) => data?.map((d: any) => d?.person?.trainerProfile) || [];
